import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import PartnershipsBar from "../components/PartnershipsBar";
import WaitingExperience from "../components/WaitingExperience";
import Testimonials from "../components/Testimonials";
import ReviewBox from "../components/ReviewBox";

export default function HomePage() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [hash]);

  return (
    <div key={pathname} className="page-transition" data-testid="page-home">
      <Hero />
      <PartnershipsBar />
      <WaitingExperience />
      <Testimonials />
      <ReviewBox />
    </div>
  );
}
